(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[20],{

/***/ "/Mt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useResponsive; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Responsive_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("GRjW");
/* harmony import */ var _getCurrentResponsive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ZCNJ");



var ResponsiveContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])(Object(_getCurrentResponsive__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
  currentBreakpoint: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_1__[/* getCurrentBreakpoint */ "a"])('', false),
  isAppMounted: false
}));
/* harmony default export */ __webpack_exports__["a"] = (ResponsiveContext);
var useResponsive = function useResponsive() {
  var context = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(ResponsiveContext);

  if (context === undefined) {
    throw new Error('useResponsive must be used within a Responsive.Provider');
  }

  return context;
};

/***/ }),

/***/ "0JpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useGQL; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _graphqlClient__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("PIvV");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("Ub5k");
















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var noop = function noop(e) {
  return e;
};

function reducer(state, action) {
  switch (action.type) {
    case 'loading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case 'data':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data,
        isLoading: false
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error,
        isLoading: false
      });

    default:
      throw new Error("Unknown action type! [".concat(action.type, "]"));
  }
}

function useGQL() {
  var initialState = {
    data: null,
    error: null,
    isLoading: true
  };

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_15__["useReducer"])(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_15__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"]);

  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  var filteredQueries = queries.filter(function (query) {
    return !query.ignore;
  });
  Object(react__WEBPACK_IMPORTED_MODULE_15__["useEffect"])(function () {
    dispatch({
      type: 'loading'
    });
    var promises = filteredQueries.map(function (_ref) {
      var query = _ref.query,
          _ref$cache = _ref.cache,
          cache = _ref$cache === void 0 ? false : _ref$cache,
          _ref$map = _ref.map,
          map = _ref$map === void 0 ? noop : _ref$map,
          queryOptions = _ref.queryOptions,
          catchCallback = _ref["catch"];
      var promise = cache ? _graphqlClient__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"].runQuery(query, appContext, queryOptions) : _graphqlClient__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"].runNoCacheQuery(query, appContext, queryOptions);

      if (catchCallback) {
        return promise.then(map)["catch"](catchCallback);
      }

      return promise.then(map);
    });
    Promise.all(promises).then(function (datas) {
      if (filteredQueries.length > 0) {
        var data = filteredQueries.length === 1 ? datas[0] : datas.reduce(function (acc, item) {
          return _objectSpread(_objectSpread({}, acc), item);
        }, {});
        dispatch({
          type: 'data',
          data: data
        });
      } else {
        dispatch({
          type: 'data',
          data: undefined
        });
      }
    })["catch"](function (error) {
      dispatch({
        type: 'error',
        error: error
      });
    });
  }, queries.map(function (q) {
    return q.query + (q.ignore ? 'T' : 'F');
  })); // useEffect run at each render on the react lifecycle. Here the useEffect should run only if the query OR the ignore param change!
  // $FlowFixMe

  return state;
}

/***/ }),

/***/ "7jla":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useRouter; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routerContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("BncX");


function useRouter() {
  // $FlowFixMe
  var router = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_routerContext__WEBPACK_IMPORTED_MODULE_1__[/* routerContext */ "a"]);
  return router;
}

/***/ }),

/***/ "BncX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var defaultRouter = null;
var routerContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext(defaultRouter);

/***/ }),

/***/ "DSo7":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "FLQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var exists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UbRG");
/* harmony import */ var exists__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(exists__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lDxO");








function getUrl(options) {
  if (!options.url) {
    return options.url;
  }

  function getOptionsPathParameters() {
    /*
     * TODO Remove this with issue #14434
     * Due to webedia and media-server incompatibility we need to replace hostname
     * and avoid multiple redirects. See issue #14141.
     */
    var encodedUrl = encodeURIComponent((options.url || '').replace('http://viaimage2.viafrance.com', 'http://viaimage3.viafrance.com'));
    var optimizedDimensions = _dictionary__WEBPACK_IMPORTED_MODULE_7__[/* getOptimalWidthAndHeight */ "b"](options.width, options.height);

    if (!_config__WEBPACK_IMPORTED_MODULE_6___default.a.get('media.apiV2.enabled')) {
      return [options.format, optimizedDimensions.width, optimizedDimensions.height, options.transform, options.transform === 'crop' ? options.gravity : null, options.quality, encodedUrl];
    }

    return [encodedUrl, options.format, optimizedDimensions.width, optimizedDimensions.height, options.transform, options.transform === 'crop' ? options.gravity : null, options.quality];
  }

  if (!_config__WEBPACK_IMPORTED_MODULE_6___default.a.get('media.apiV2.enabled')) {
    return [_config__WEBPACK_IMPORTED_MODULE_6___default.a.get('media.host'), 'image'].concat(getOptionsPathParameters()).filter(exists__WEBPACK_IMPORTED_MODULE_5___default.a).join('/');
  }

  return [_config__WEBPACK_IMPORTED_MODULE_6___default.a.get('media.host'), 'v2', 'image'].concat(getOptionsPathParameters()).filter(exists__WEBPACK_IMPORTED_MODULE_5___default.a).join('/');
}

/***/ }),

/***/ "GRjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDOMAspect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLandscape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isRTL; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("I6kL");






function getDOMAspect(isAppMounted) {
  var domCharacteristics = {
    viewportWidthPX: 0,
    viewportHeightPX: 0,
    htmlFontSize: 0
  };

  if (isAppMounted) {
    domCharacteristics = {
      viewportWidthPX: _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getClientWidth(),
      viewportHeightPX: _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getClientHeight(),
      htmlFontSize: parseInt(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getFontSize(), 10)
    };
  }

  return domCharacteristics;
}

function getCurrentBreakpoint() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isAppMounted = arguments.length > 1 ? arguments[1] : undefined;

  if (!isAppMounted) {
    if (_config__WEBPACK_IMPORTED_MODULE_3___default.a.get('featureFlipping.ssr.mobile-first') || !userAgent || /(mobile|tablet|iPhone|iPad|Android)/i.test(userAgent)) {
      return _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_4__[/* BREAKPOINTS */ "a"].XXS;
    }

    return _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_4__[/* BREAKPOINTS */ "a"].XL;
  }

  return _Responsive_constants_js__WEBPACK_IMPORTED_MODULE_4__[/* MEDIA_QUERIES */ "b"].reduce(function (previousValue, currentValue) {
    return _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].matchMediaQuery(currentValue.mediaquery) ? currentValue : previousValue;
  }).breakpoint;
}

function isLandscape(isAppMounted) {
  return isAppMounted ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].matchMediaQuery('all and (orientation:landscape)') : false;
}

function isRTL(isAppMounted) {
  return isAppMounted ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getDocumentElement().dir === 'rtl' : false;
}



/***/ }),

/***/ "I/kN":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("w7mb");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "I6kL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BREAKPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ORDERED_BREAKPOINTS; });
/* unused harmony export DEFAULT_CELL_COLS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIA_QUERIES; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");

var BREAKPOINTS = {
  XXS: 'XXS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL'
};
var ORDERED_BREAKPOINTS = [BREAKPOINTS.XXS, BREAKPOINTS.XS, BREAKPOINTS.S, BREAKPOINTS.M, BREAKPOINTS.L, BREAKPOINTS.XL];
var MEDIA_QUERIES = [{
  breakpoint: BREAKPOINTS.XXS,
  mediaquery: '(min-width: 0)'
}, {
  breakpoint: BREAKPOINTS.XS,
  mediaquery: '(min-width: 22.51em)'
}, {
  breakpoint: BREAKPOINTS.S,
  mediaquery: '(min-width: 40.01em)'
}, {
  breakpoint: BREAKPOINTS.M,
  mediaquery: '(min-width: 50.01em)'
}, {
  breakpoint: BREAKPOINTS.L,
  mediaquery: '(min-width: 64.01em)'
}, {
  breakpoint: BREAKPOINTS.XL,
  mediaquery: '(min-width: 76.26em)'
}];

var DEFAULT_CELL_COLS = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, BREAKPOINTS.XXS, 12);



/***/ }),

/***/ "Iev9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAuthentication; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ub5k");


function useAuthentication() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"]);
  return {
    isLogged: appContext.isUserLogged,
    isQuickLogged: appContext.isUserQuickLogged
  };
}

/***/ }),

/***/ "J9Yr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("7x/C");

__webpack_require__("OZaJ");

__webpack_require__("DZ+c");

var _toConsumableArray = __webpack_require__("iN+R");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _assertThisInitialized = __webpack_require__("N7I1");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports.default = void 0;

var _react = __webpack_require__("ERkP");

var isServer = false;

var _default = /*#__PURE__*/function (_react$Component) {
  _inherits(_default, _react$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._hasHeadManager = void 0;

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.delete(this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _default;
}(_react.Component);

exports.default = _default;

/***/ }),

/***/ "N7I1":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "TZT2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AmpStateContext = /*#__PURE__*/_react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ "UbRG":
/***/ (function(module, exports) {

module.exports = exists;

module.exports.allExist = allExist;

function exists (v) {
  return v !== null && v !== undefined;
}

function allExist (/* vals */) {
  var vals = Array.prototype.slice.call(arguments);
  return vals.every(exists);
}

/***/ }),

/***/ "ZCNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var _Responsive_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("GRjW");
/* harmony import */ var _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("I6kL");





function isBrowserGreaterThan(currentBreakpoint) {
  var breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XXS;
  var currentBpIndex = _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* ORDERED_BREAKPOINTS */ "c"].indexOf(currentBreakpoint);
  var stepIndex = _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* ORDERED_BREAKPOINTS */ "c"].indexOf(breakpoint);
  return currentBpIndex > stepIndex;
}

function isDesktop(currentBreakpoint) {
  return currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].L || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XL;
}

function isTablet(currentBreakpoint) {
  return isDesktop(currentBreakpoint) || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].M || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].S;
}

function isMobile(currentBreakpoint) {
  return isTablet(currentBreakpoint) || currentBreakpoint === _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XS;
}

function getCurrentResponsive(_ref) {
  var _isBrowserGreaterThan;

  var currentBreakpoint = _ref.currentBreakpoint,
      isAppMounted = _ref.isAppMounted;
  return {
    isAppMounted: isAppMounted,
    currentBreakpoint: currentBreakpoint,
    domAspect: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_2__[/* getDOMAspect */ "b"])(isAppMounted),
    isLandscape: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_2__[/* isLandscape */ "c"])(isAppMounted),
    isMobile: isMobile(currentBreakpoint),
    isRTL: Object(_Responsive_helper__WEBPACK_IMPORTED_MODULE_2__[/* isRTL */ "d"])(isAppMounted),
    isTablet: isTablet(currentBreakpoint),
    isDesktop: isDesktop(currentBreakpoint),
    isBrowserGreaterThan: (_isBrowserGreaterThan = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XXS, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XXS)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XS, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].XS)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].S, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].S)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].M, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].M)), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_isBrowserGreaterThan, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].L, isBrowserGreaterThan(currentBreakpoint, _Responsive_constants__WEBPACK_IMPORTED_MODULE_3__[/* BREAKPOINTS */ "a"].L)), _isBrowserGreaterThan)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getCurrentResponsive);

/***/ }),

/***/ "apzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfoSelector; });
var userInfoSelector = function userInfoSelector(state) {
  return state.userInfo;
};

/***/ }),

/***/ "bOkD":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("cHE3");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "cMav":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("i2RQ");

var assertThisInitialized = __webpack_require__("N7I1");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "dq4L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _ampContext = __webpack_require__("TZT2");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react.default.useContext(_ampContext.AmpStateContext));
}

/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "iN+R":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("bOkD");

var iterableToArray = __webpack_require__("DSo7");

var unsupportedIterableToArray = __webpack_require__("D7XE");

var nonIterableSpread = __webpack_require__("uYlf");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "lDxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ defaultDictionnary; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getOptimalWidthAndHeight; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// CONCATENATED MODULE: ./src/client/components/utils/media-server/createDictionnary.js



function createDictionnary(widthRanges, widthDelta) {
  function getWidthRanges() {
    return widthRanges;
  }

  function getWidthDelta() {
    return widthDelta;
  }

  function getOptimalWidth(width) {
    var foundWidth = widthRanges.find(function (currentAllowedWidth) {
      return width <= currentAllowedWidth + widthDelta;
    });
    return foundWidth ? foundWidth : widthRanges.slice(-1)[0];
  }

  function getTransformationRatio(previous, next) {
    return next / previous;
  }

  function getOptimalHeight(currentHeight, ratio) {
    return typeof currentHeight === 'number' && ratio !== Infinity ? Math.ceil(currentHeight * ratio) : currentHeight;
  }

  function getOptimalWidthAndHeight(width, height) {
    var finalWidth = getOptimalWidth(width);
    var ratio = getTransformationRatio(width, finalWidth);
    var finalHeight = getOptimalHeight(height, ratio);
    return {
      width: finalWidth,
      height: finalHeight
    };
  }

  return {
    getOptimalWidth: getOptimalWidth,
    getOptimalWidthAndHeight: getOptimalWidthAndHeight,
    getWidthRanges: getWidthRanges,
    getWidthDelta: getWidthDelta
  };
}

/* harmony default export */ var media_server_createDictionnary = (createDictionnary);
// CONCATENATED MODULE: ./src/client/components/utils/media-server/dictionary.js

var defaultDictionnary = media_server_createDictionnary([300, 400, 600, 900, 1024, 1200, 2000], 50);
var getOptimalWidthAndHeight = defaultDictionnary.getOptimalWidthAndHeight;


/***/ }),

/***/ "op+c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HeadManagerContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeadManagerContext = /*#__PURE__*/_react.default.createContext({});

exports.HeadManagerContext = HeadManagerContext;

if (false) {}

/***/ }),

/***/ "pSQP":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "uYlf":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "vpUC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ysqo")


/***/ }),

/***/ "wFPu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var isArray = __webpack_require__("xt6W");

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ "ysqo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("1t7P");

__webpack_require__("2G9S");

__webpack_require__("LW0h");

__webpack_require__("jwue");

__webpack_require__("vrRf");

__webpack_require__("lTEL");

__webpack_require__("z84I");

__webpack_require__("KOtZ");

__webpack_require__("wFPu");

__webpack_require__("M+/F");

__webpack_require__("5BYb");

__webpack_require__("daRM");

__webpack_require__("FtHn");

__webpack_require__("+KXO");

__webpack_require__("7x/C");

__webpack_require__("LqLs");

__webpack_require__("87if");

__webpack_require__("3voH");

__webpack_require__("ZUdG");

__webpack_require__("+oxZ");

__webpack_require__("kYxP");

var _defineProperty = __webpack_require__("O5Wi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.defaultHead = defaultHead;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _sideEffect = _interopRequireDefault(__webpack_require__("J9Yr"));

var _ampContext = __webpack_require__("TZT2");

var _headManagerContext = __webpack_require__("op+c");

var _amp = __webpack_require__("dq4L");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
returns a function for filtering head child elements
which shouldn't be duplicated, like <title/>
Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if (categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
*
* @param headElements List of multiple <Head> instances
*/


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react.default.Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if (false) { var newProps; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
* This component injects elements to `<head>` of your page.
* To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
*/


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react.useContext)(_ampContext.AmpStateContext);
  var headManager = (0, _react.useContext)(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp.isInAmpMode)(ampState)
  }, children);
} // TODO: Remove in the next major release


Head.rewind = function () {};

var _default = Head;
exports.default = _default;

/***/ })

}]);